// The async Clipboard API only exists in a "secure context" (HTTPS, or
// localhost). Reached over plain http:// on a LAN IP -- the normal way to
// open this app from a phone -- `navigator.clipboard` is simply undefined.
// Copy still works there via the legacy execCommand trick; programmatic
// paste has no such fallback, so it degrades to a clear message instead of
// silently doing nothing.

export async function copyToClipboard(text: string): Promise<boolean> {
  if (window.isSecureContext && navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // fall through to the legacy path
    }
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  let ok = false;
  try {
    ok = document.execCommand("copy");
  } catch {
    ok = false;
  }
  textarea.remove();
  return ok;
}

export async function pasteFromClipboard(): Promise<string | null> {
  if (window.isSecureContext && navigator.clipboard) {
    try {
      return await navigator.clipboard.readText();
    } catch {
      return null;
    }
  }
  return null;
}
